import { AxiosError } from "axios";
import { StateCreator } from "zustand";

export interface ErrorSlice {
  error: AxiosError;
  setError: (error: AxiosError) => void;
}

const createErrorSlice: StateCreator<ErrorSlice, [], [], ErrorSlice> = (
  set,
) => ({
  error: {} as AxiosError,
  setError: (error: AxiosError) => set({ error }),
});

export default createErrorSlice;
